module.exports = __webpack_public_path__ + "img/3.5e6b1331.png";